<template>
  <Sheet>
    <Sheet.Body class="px-0! pt-[11px]">
      <Sheet.MenuItem :icon="CheckmarkIcon" @click="handleMarkAllAsRead">
        Mark all as read
      </Sheet.MenuItem>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CheckmarkIcon } from '@dacr/icons'
import { useNotificationsRead } from '@/shared/composables/useNotificationsRead'

const { close } = useSheet()
const { markAllRead } = useNotificationsRead()

const handleMarkAllAsRead = () => {
  markAllRead()
  close()
}
</script>
